import { IPaginatedResponse, IResponse } from "../../../model";
import ServiceBase from "../../../servicebase";
import { ISegmento } from "../model/ISegmento";

export default class SegmentoService extends ServiceBase {
  all = () : Promise<IResponse<ISegmento[]>> => 
    this.GetFetch<IResponse<ISegmento[]>>('entity/segmento/all', {});

  get = (data:{ id?: number }) : Promise<IResponse<ISegmento>> => 
    this.GetFetch<IResponse<ISegmento>>('entity/segmento', data);

  find = (data:{ pageIndex?: number, pageSize?: number, sort?: string,
    id?: number, nombre?: string, codigo?: string, activo?: boolean }) : Promise<IPaginatedResponse<ISegmento>> => 
    this.GetFetch<IPaginatedResponse<ISegmento>>('entity/segmento/find', data);

  upsert = (data:ISegmento) : Promise<IResponse<ISegmento>> => 
    this.PostFetch<IResponse<ISegmento>>('entity/segmento', data);

  delete = (data:{ id:number, undelete?: boolean}) : Promise<IResponse<void>> => 
    this.DeleteFetch<IResponse<void>>('entity/segmento', data);

}
